<div class="panel" style="padding: 1%;">
        

    <div class="row">

    <!-- Customer -->
    <div class="col-md-4">
        <mat-form-field class="header-form-full-width">
            <span class="label">{{'Customer' | translate | async}}</span>

            <mat-select
                id="select-customer"
                placeholder="{{'Select Customer' | translate | async}}"
                [(ngModel)]="selectedCustomer"
                (selectionChange)="loadJobsitesForCustomer();"
                ngDefaultControl
                multiple>

                <mat-option
                    [value]="customer.Id"
                    *ngFor="let customer of customerList">

                    {{customer.Name}}

                </mat-option>

            </mat-select>
        </mat-form-field>
    </div>

    <!-- Start Date -->
    <div class="col-md-4">
        <span class="label">{{'Start Date' | translate | async}}</span>

        <mat-form-field class="header-form-full-width">
            <input
                matInput
                [matDatepicker]="startDatePicker"
                placeholder="{{'Start Date'|translate | async}}"
                [(ngModel)]="startDate"
                [formControl]="StartDateControl" (click)="startDatePicker.open()">

            <mat-datepicker-toggle
                matSuffix
                [for]="startDatePicker">
            </mat-datepicker-toggle>

            <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>
    </div>

    <!-- End Date -->
    <div class="col-md-4">
        <span class="label">{{'End Date' | translate | async}}</span>

        <mat-form-field class="header-form-full-width">
            <input
                matInput
                [matDatepicker]="endDatePicker"
                placeholder="{{'End Date'|translate|async}}"
                [(ngModel)]="endDate"
                ngDefaultControl (click)="endDatePicker.open()">

            <mat-datepicker-toggle
                matSuffix
                [for]="endDatePicker">
            </mat-datepicker-toggle>

            <mat-datepicker #endDatePicker></mat-datepicker>
        </mat-form-field>
    </div>
</div>
<div class="row">
    <!-- Equipment -->
    <div class="col-md-4">
        <mat-form-field class="header-form-full-width">
            <span class="label">{{'Equipment' |translate | async}}</span>

            <mat-select
                id="select-equipment-serialno"
                placeholder="{{'Select Equipment' | translate | async}}"
                [(ngModel)]="selectedEquipment"
                ngDefaultControl
                multiple>

                <mat-option
                    [value]="equipment.Id"
                    *ngFor="let equipment of equipmentList">

                    {{equipment.SerialNumber}} : {{equipment.UnitNumber}}

                </mat-option>

            </mat-select>
        </mat-form-field>
    </div>

    <!-- Log Sent -->
    <div class="col-md-4">
        <span class="label">{{'Start Time' | translate | async}}</span>

        <mat-form-field class="header-form-full-width">

            <mat-select
                id="log-sent"
                placeholder="{{'Log Sent' | translate | async}}"
                [(ngModel)]="selectedLogSent"
                ngDefaultControl>

                <mat-option [value]="0">
                    {{'All' | translate | async}}
                </mat-option>

                <mat-option [value]="1">
                    {{'Sent' | translate | async}}
                </mat-option>

                <mat-option [value]="2">
                    {{'Not Sent' | translate | async}}
                </mat-option>

            </mat-select>

        </mat-form-field>
    </div>

    <!-- Report Number -->
    <div class="col-md-4">
        <mat-form-field class="header-form-full-width">
            <span class="label">{{'Report Number' | translate | async}}</span>

            <input
                matInput
                placeholder="{{'Report Number' | translate | async}}"
                type="text"
                [(ngModel)]="LabNumber">
        </mat-form-field>
    </div>

   
    <!-- Buttons -->
    

</div>

<div class="row">
   <!-- Email -->
    <div class="col-md-4">
        <mat-form-field class="header-form-full-width">
            <span class="label">{{'Email' | translate | async}}</span>

            <input
                matInput
                placeholder="{{'Email' | translate | async}}"
                type="email"
                [(ngModel)]="Email">
        </mat-form-field>
    </div>
    <div class="col-md-4">
        
    </div>

        <div class="flex flex--align-center" style="margin-top:25px;float:right">

            <a class="button" (click)="ResetFields();">
                <span class="button__text">
                    {{'Reset' | translate | async}}
                </span>
            </a>

            <a class="button button--primary" (click)="submitSelection()">
                <i class="material-icons button__icon">search</i>

                <span class="button__text">
                    {{'Search' | translate | async}}
                </span>
            </a>

        </div>
    </div>

  <mat-tab-group *ngIf="(performSearch) && !hidematgroup">
      <mat-tab label="{{'Email Log' | translate | async}}">
              <div id="equipment-implement-list">      
                  <panel class="no-padding table-panel">
                    <div class="spinner" *ngIf="retrievingEmailFaxLogResults">
                      <mat-spinner diameter="30"></mat-spinner>
                    </div>
                    <table class="table table--full-width table--striped table--hover table--sortable" style="table-layout: unset;" *ngIf="!retrievingEmailFaxLogResults">
                      <thead>
                        <tr>
                         <th (click)="sortBy('Customer')" width="150px">{{'Customer' | translate | async}}</th>
                         <th (click)="sortBy('SerialNumber')" width="130px">{{'Equipment' | translate | async}}</th>
                         <th  width="130px">{{'Unit Number' | translate | async}}</th>
                         <!-- (click)="sortBy('UnitNumber')" -->
                         <th (click)="sortBy('LabNumber')" width="130px">{{'Report No' | translate | async}}</th>
                          <th (click)="sortBy('LogDate')" width="140px">{{'Log Date' | translate | async}}</th>
                          <!-- <th (click)="sortBy('LogTime')" width="130px">{{'Log Time' | translate | async}}</th> -->
                          <!-- <th (click)="sortBy('Username')" width="130px">{{'Send To Name' | translate | async}}</th> -->
                          <th (click)="sortBy('SentToAddress')" width="130px">{{'Sent To Address' | translate | async}}</th>
                          <th (click)="sortBy('Type')" width="130px">{{'Type' | translate | async}}</th>
                          <th  width="130px">{{'Sent' | translate | async}}</th>  
                          <!-- (click)="sortBy('IsMailSent')" -->
                          <!-- <th width="70px">
                            <mat-checkbox (change)="$event ? masterToggle() : null"
                                [checked]="selection.hasValue() && isAllSelected()"
                                [indeterminate]="selection.hasValue() && !isAllSelected()">
                            </mat-checkbox>
                       </th> -->
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let emailLog of emailFaxLogResults">
                          <ng-container *ngIf="!loadingRow">
                            <td  [@fadeIn] [attr.title]="emailLog.customer">{{emailLog.customer}}</td>
                            <td  [@fadeIn] [attr.title]="emailLog.equipment">{{emailLog.equipment | truncate:[13]}}</td>
                            <td  [@fadeIn] [attr.title]="emailLog.unitNumber">{{emailLog.unitNumber | truncate:[13]}}</td>
                            <td  [@fadeIn] [attr.title]="emailLog.LabNumber">{{emailLog.LabNumber | truncate:[18]}}</td>           
                            <td  [@fadeIn]>{{emailLog.LogDate | date:'dd/MMM/yyyy'}} {{emailLog.LogTime | date:'HH:mm:ss'}} </td>                                      
                            <!-- <td  [@fadeIn]>{{emailLog.LogTime | date:'dd/MMM/yyyy'}}</td> -->
                            <!-- <td  [@fadeIn] [attr.title]="emailLog.Username">{{emailLog.Username | truncate:[13]}}</td> -->
                            <td  [@fadeIn] [attr.title]="emailLog.SentToAddress">{{emailLog.SentToAddress}}</td>
                            <td  [@fadeIn] [attr.title]="emailLog.SourceType">{{emailLog.SourceType | truncate:[13]}}</td>
                            <td  [@fadeIn] [attr.title]="emailLog.EmailStatus">{{emailLog.EmailStatus }}</td>
                            <!-- <td  [@fadeIn] [attr.title]="emailLog.IsMailSent">
                                <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(emailLog) : null"
                                    [checked]="selection.isSelected(emailLog.IsMailSent)">
                                </mat-checkbox>
                            </td> -->
                            
                          </ng-container>
                          <ng-container *ngIf="loadingRow">
                            <td colspan="10">
                              <div class="ph-item" style="height: 33px;">
                                <div class="ph-row">
                                  <div class="ph-col-12"></div>
                                </div>
                              </div>
                            </td>
                          </ng-container>
                        </tr>                       
                      </tbody>
                    </table>
                    <mat-paginator [pageIndex]="pageNumber" [length]="totalResults" [pageSize]="emailLogPageSize" [pageSizeOptions]="[5, 10, 25, 100]"
                      (page)="onPageEvent($event)">
                    </mat-paginator>
                  </panel>


              </div>
      </mat-tab>

  </mat-tab-group>
</div>

<div class="emptyscreen" *ngIf="!performSearch || hidematgroup ">{{'Please use the Search field above to select what Email Log you are shown.' | translate | async}}</div>